module.exports = __webpack_public_path__ + "static/media/upload-confirm@2x.2a44eb9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/upload-confirm@2x.png
// module id = 924
// module chunks = 0